import React from "react";
import { Route } from "react-router";
import { Content } from "./Content";

/**
 * Factory that returns a `<Route>` element whose rendered page is wrapped in
 * `<Content>` (for the Metronic layout animation hook).
 *
 * v7 React Router requires every child of `<Routes>` to be a `<Route>`
 * element. Wrapper components no longer work. So this is a *function*, not a
 * component — call it inside JSX as `{ContentRoute({ path, component })}`.
 *
 * @param {{ path: string, component?: React.ComponentType, element?: React.ReactNode, children?: React.ReactNode } & Record<string, unknown>} opts
 * @returns {JSX.Element}
 */
export function ContentRoute({ path, component: Component, element, children, ...rest }) {
  const inner = element ?? (Component ? <Component /> : children);
  return <Route key={path} path={path} element={<Content>{inner}</Content>} {...rest} />;
}
